<template>
    <div v-if="isComplete" class="w-full flex-wrap flex">
        <div 
            v-if="image" 
            class="transition-all delay-300" 
            :class="[size === 'small' ? 'h-[50px]' : 'h-[125px]']"
        >
            <img :src="image" class="max-h-full" />
        </div>
    </div>

    <div
        v-else-if="focused"
        class="w-full flex-wrap flex pb-2"
        :class="[isSmallCylinder ? 'md:w-1/3' : 'w-auto']"
    >
        <!-- Left Section -->
        <div
            class="border-r border-dashed border-dgreen pb-10 relative"
            :class="[isSmallCylinder ? 'w-1/2' : 'w-auto']"
        >
            <div
                v-if="!cylinder.a"
                class="border-l border-dashed border-dgreen absolute bottom-0 w-[93px] right-0 text-center px-4 py-2"
            >
                <img :src="asset('img/arrows-left-right-light.svg')" class="mx-auto w-full pulse-size" />
            </div>
            <div v-if="image" :class="[size === 'small' ? 'h-[50px]' : 'h-[125px]']" class="overflow-hidden">
                <img :src="image" :class="[size === 'small' ? 'h-[50px]' : 'h-[125px]']" class="-mr-[97px] float-right relative block max-w-none" />
            </div>
        </div>

        <!-- Right Section -->
        <div
            class="pb-10 relative"
            :class="[!cylinder.b ? 'w-1/2' : 'w-auto']"
        >
            <div
                v-if="cylinder.a && !cylinder.b"
                class="border-r border-dashed border-dgreen absolute bottom-0 left-0 w-[93px] text-center px-4 py-2"
            >
                <img :src="asset('img/arrows-left-right-light.svg')" class="mx-auto w-full pulse-size" />
            </div>
            <div v-if="image" :class="[size === 'small' ? 'h-[50px]' : 'h-[125px]']" class="overflow-hidden">
                <img
                    v-if="default_image"
                    :src="default_image"
                    :class="[size === 'small' ? 'h-[50px]' : 'h-[125px]', { 'opacity-20': !cylinder.a }]"
                    class="-ml-[99px] relative block max-w-none"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    size: {
        type: String,
        default: 'normal'
    },
    image: {
        type: [String, Boolean],
        default: false
    },
    default_image: {
        type: [String, Boolean], 
        default: false
    },
    cylinder: {
        type: [Object, Boolean],
        default: false
    },
    focused: {
        type: Boolean,
        default: false
    }
});

const isComplete = computed(() => props.cylinder?.a > 0 && props.cylinder?.b > 0);
const isSmallCylinder = computed(() => !props.cylinder?.a || props.cylinder?.a < 50);
</script>
